"use strict";
// (C) 2021-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveInsights = void 0;
var tslib_1 = require("tslib");
var sdk_model_1 = require("@gooddata/sdk-model");
var effects_1 = require("redux-saga/effects");
var insightsSelectors_1 = require("../store/insights/insightsSelectors");
var objRefMap_1 = require("../../_staging/metadata/objRefMap");
function loadInsightsFromBackend(ctx, insightRefs) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var backend, workspace, result;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    backend = ctx.backend, workspace = ctx.workspace;
                    return [4 /*yield*/, Promise.all(insightRefs.map(function (ref) {
                            return backend
                                .workspace(workspace)
                                .insights()
                                .getInsight(ref)
                                .catch(function (_) { return ref; });
                        }))];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, {
                            loaded: result.filter(sdk_model_1.isInsight),
                            missing: result.filter(sdk_model_1.isObjRef),
                        }];
            }
        });
    });
}
/**
 * Given a list of insight ObjRefs, this generator will resolve those refs to actual IInsight objects. The resolution
 * is done from two sources: first the insights already stored in the lazily-populated insight slice, second, as a fallback
 * the actual analytical backend.
 *
 * @param ctx - dashboard context in which the resolution is done
 * @param insightRefs - refs of insights to resolve to IInsight
 */
function resolveInsights(ctx, insightRefs) {
    var alreadyLoadedInsights, foundInsights, missingInsightRefs, loadResult;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(insightsSelectors_1.selectInsightsMap)];
            case 1:
                alreadyLoadedInsights = _a.sent();
                foundInsights = [];
                missingInsightRefs = [];
                insightRefs.forEach(function (ref) {
                    var insight = alreadyLoadedInsights.get(ref);
                    if (insight) {
                        foundInsights.push(insight);
                    }
                    else {
                        missingInsightRefs.push(ref);
                    }
                });
                return [4 /*yield*/, effects_1.call(loadInsightsFromBackend, ctx, missingInsightRefs)];
            case 2:
                loadResult = _a.sent();
                return [2 /*return*/, {
                        resolved: objRefMap_1.newInsightMap(tslib_1.__spread(foundInsights, loadResult.loaded)),
                        loaded: loadResult.loaded,
                        missing: loadResult.missing,
                    }];
        }
    });
}
exports.resolveInsights = resolveInsights;
//# sourceMappingURL=insightResolver.js.map